export const host = process.env.VUE_APP_API_HOST